import React, { FC } from 'react';
import { Box } from '@mui/material';
import AcceptTerms from '../components/Terms/AcceptTerms';

const TermsAndConditions: FC = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingY: '10vh' }}>
          <AcceptTerms />
        </Box>
      </Box>
    </Box>
  );
};

export default TermsAndConditions;
